import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  type IPractice,
  type ITwilioPracticeNumber,
} from '@principle-theorem/principle-core/interfaces';
import { type DocumentReference } from '@principle-theorem/shared';

export class TwilioPracticeNumberFormGroup extends TypedFormGroup<
  Omit<ITwilioPracticeNumber, 'disabled'>
> {
  constructor() {
    super({
      practiceRef: new TypedFormControl<DocumentReference<IPractice>>(
        undefined,
        [Validators.required]
      ),
      phoneNumber: new TypedFormControl<string>(undefined, [
        Validators.required,
        Validators.pattern(/^\+\d+$/),
      ]),
    });
  }
}
